module.exports = __webpack_public_path__ + "static/media/wirvsvirus.96f0cc9a.png";